/* eslint-disable import/prefer-default-export,react/forbid-prop-types,import/no-unresolved,jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { MAIN_ICON_COLORS } from 'assets/components';
import BackgroundCard from 'assets/images/us-card-bg.png';
import { useTranslation } from 'react-i18next';
import CLLogo from 'assets/images/cl-logo.svg';
import { formatNumberWithComma } from '../../../../utilities/formatHelpers';
import { CardLogo } from '../CardLogo';
import { cardProviders } from '../../../../screens/Card/constants';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { Typography } from '../../../../components';

export const ActiveCard = ({
  handleFlip = () => {},
  cardStatus = null,
  cardProvider = null,
  amount = 0,
  currency = '',
  label = '',
  openCardCurrencyNote,
  openCardSettingModal,
}) => {
  const history = useHistory();
  const { t: translate } = useTranslation();
  const { path } = useRouteMatch();
  const amountRef = useRef();
  const [currencyXCoordinate, setCurrencyXCoordinate] = useState(-100);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  const displayedCardCurrency =
    cardStatus?.cardCurrency?.toUpperCase() || cardStatus?.currency?.toUpperCase();
  const calculatePositions = () => {
    if (amountRef.current) {
      setCurrencyXCoordinate(25 + amountRef.current.getComputedTextLength());
    }
  };

  useEffect(() => {
    setTimeout(calculatePositions, 500);
  }, [amount, currency]);

  if (cardProvider === cardProviders.GALILEO) {
    return (
      <div className="us-card-gradient-box">
        <div
          style={{
            height: '15rem',
          }}
          className="d-flex flex-column position-relative w-100 rounded-extra pb-0">
          <div
            className="w-100 h-100 position-absolute top-0 left-0 rounded-extra"
            style={{
              opacity: '70%',
              backgroundImage: `url(${BackgroundCard})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
          <div className="d-flex flex-column px-3 pt-3 h-100" style={{ zIndex: 10 }}>
            <div className="d-flex flex-row justify-content-between pb-5">
              <div className="d-flex align-items-center">
                <div style={{ width: '5.8rem', height: '1.6rem' }}>
                  <img src={CLLogo} alt="logo" />
                </div>
              </div>
              <div className="d-flex flex-row" style={{ gap: '0.75rem' }}>
                <div className="position-relative d-flex justify-content-center align-items-center rounded-extra p-2 cursor-pointer">
                  <div
                    className="position-absolute rounded-extra bg-shadow top-0 bottom-0 bg-shadow w-100 h-100"
                    style={{ backdropFilter: 'blur(4px)', opacity: '0.6' }}
                  />
                  <div
                    onClick={() => handleFlip()}
                    tabIndex={-1}
                    role="presentation"
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: '1.3rem', height: '1.3rem', zIndex: 10 }}>
                    <Icon icon={ICONS.OUTLINE_CARD} color={MAIN_ICON_COLORS.WHITE} />
                  </div>
                </div>
                <div className="position-relative d-flex justify-content-center align-items-center rounded-extra p-2 cursor-pointer">
                  <div
                    className="position-absolute rounded-extra bg-shadow top-0 bottom-0 bg-shadow w-100 h-100"
                    style={{ backdropFilter: 'blur(4px)', opacity: '0.6' }}
                  />
                  <div
                    onClick={() => openCardSettingModal()}
                    tabIndex={-1}
                    role="presentation"
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: '1.3rem', height: '1.3rem', zIndex: 10 }}>
                    <Icon icon={ICONS.SETTING} color={MAIN_ICON_COLORS.WHITE} />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-row align-items-end pb-4">
              <Typography
                as="p"
                variant="xLargeBold"
                className="text-white text-simple-shadow me-2">
                {formatNumberWithComma(amount)}
              </Typography>
              <p
                className="text-white text-simple-shadow text-f5 fw-bold"
                style={{ lineHeight: 1 }}>
                {displayedCardCurrency}
              </p>
              <div
                onClick={isMobile ? () => openCardCurrencyNote() : () => {}}
                className="flex-row d-flex position-relative justify-content-center align-items-center ms-2"
                data-tooltip-id="card-currency-tooltip"
                role="button"
                tabIndex={-1}
                onMouseEnter={() => setShowInfoPopup(true)}
                onKeyDown={null}
                onMouseLeave={() => setShowInfoPopup(false)}>
                <i
                  className={`icon icon-info-icon text-f5 rotate-180 ${
                    showInfoPopup ? 'text-primary' : 'text-dark'
                  }`}
                />
              </div>
            </div>
            <div className="d-flex flex-row flex-fill justify-content-between align-items-center">
              <button
                onClick={() => {
                  history.push(`${path}/accounts`);
                }}
                type="button"
                className="btn btn-primary px-3"
                style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                {translate('topup_button_label')}
              </button>
              <CardLogo
                cardProvider={cardProvider}
                cardNetwork={cardStatus?.network?.toUpperCase() || ''}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 370 218"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="370" height="218" rx="12" fill="black" />
      <rect
        opacity="0.6"
        x="0.5"
        y="0.5"
        width="369"
        height="217"
        rx="11.5"
        fill="url(#paint0_linear_19084_153888)"
        stroke="url(#paint1_linear_19084_153888)"
      />
      <CardLogo
        cardProvider={cardProvider}
        cardNetwork={cardStatus?.network?.toUpperCase() || ''}
      />

      <g>
        <text ref={amountRef} fill="white" fontWeight="bold" fontSize="34" x="20" y="130">
          {formatNumberWithComma(amount)}
        </text>
        <>
          <text x={currencyXCoordinate} y="130" fontWeight={600} fill="#717070" fontSize="17">
            {displayedCardCurrency}
          </text>
          <g
            onClick={isMobile ? () => openCardCurrencyNote() : () => {}}
            onMouseEnter={() => setShowInfoPopup(true)}
            onMouseLeave={() => setShowInfoPopup(false)}
            data-tooltip-id="card-currency-tooltip">
            <rect x={currencyXCoordinate + 40} y="115" width="15" height="15" fill="transparent" />
            <svg x={currencyXCoordinate + 40} y={115} pointerEvents="none">
              <path
                pointerEvents="all"
                d="M7.03135 13.667C10.69 13.667 13.6667 10.6763 13.6667 7.00033C13.6667 3.32433 10.676 0.333658 7.00002 0.333658C3.32402 0.333657 0.333354 3.32432 0.333354 7.00032C0.333353 10.6763 3.33802 13.667 7.03135 13.667ZM7.00002 1.66699C9.94069 1.66699 12.3334 4.05966 12.3334 7.00033C12.3334 9.94099 9.95535 12.3337 7.03135 12.3337C4.07269 12.3337 1.66669 9.94099 1.66669 7.00032C1.66669 4.05966 4.05935 1.66699 7.00002 1.66699Z"
                fill={showInfoPopup ? MAIN_ICON_COLORS.PRIMARY : MAIN_ICON_COLORS.SHADOW}
              />
              <path
                pointerEvents="all"
                d="M7.66669 10.334L6.33335 10.334L6.33335 6.33398L7.66669 6.33398L7.66669 10.334ZM7.66669 5.00065L6.33335 5.00065L6.33336 3.66732L7.66669 3.66732L7.66669 5.00065Z"
                fill={showInfoPopup ? MAIN_ICON_COLORS.PRIMARY : MAIN_ICON_COLORS.SHADOW}
              />
            </svg>
          </g>
        </>
      </g>

      <g transform="translate(15,165)">
        <rect
          width="112"
          height="36"
          rx="18"
          fill="#FF5300"
          className="cursor-pointer link-card-btn"
          onClick={() => {
            history.push(`${path}/accounts`);
          }}
        />

        <path
          d="M17.3398 23V14.4336H18.7461V21.8047H22.3848V23H17.3398ZM25.1035 16.5137V23H23.7266V16.5137H25.1035ZM24.4238 14.0293C24.6348 14.0293 24.8164 14.0859 24.9688 14.1992C25.125 14.3125 25.2031 14.5078 25.2031 14.7852C25.2031 15.0586 25.125 15.2539 24.9688 15.3711C24.8164 15.4844 24.6348 15.541 24.4238 15.541C24.2051 15.541 24.0195 15.4844 23.8672 15.3711C23.7188 15.2539 23.6445 15.0586 23.6445 14.7852C23.6445 14.5078 23.7188 14.3125 23.8672 14.1992C24.0195 14.0859 24.2051 14.0293 24.4238 14.0293ZM30.459 16.3906C31.1895 16.3906 31.7578 16.5801 32.1641 16.959C32.5742 17.334 32.7793 17.9375 32.7793 18.7695V23H31.4023V19.0273C31.4023 18.5234 31.2988 18.1465 31.0918 17.8965C30.8848 17.6426 30.5645 17.5156 30.1309 17.5156C29.502 17.5156 29.0645 17.709 28.8184 18.0957C28.5762 18.4824 28.4551 19.043 28.4551 19.7773V23H27.0781V16.5137H28.1504L28.3438 17.3926H28.4199C28.5605 17.166 28.7344 16.9805 28.9414 16.8359C29.1523 16.6875 29.3867 16.5762 29.6445 16.502C29.9062 16.4277 30.1777 16.3906 30.459 16.3906ZM36.084 13.8828V18.2891C36.084 18.4883 36.0762 18.707 36.0605 18.9453C36.0449 19.1797 36.0293 19.4004 36.0137 19.6074H36.043C36.1445 19.4707 36.2656 19.3105 36.4062 19.127C36.5508 18.9434 36.6875 18.7832 36.8164 18.6465L38.7969 16.5137H40.3789L37.7832 19.3027L40.5488 23H38.9316L36.8574 20.1523L36.084 20.8145V23H34.707V13.8828H36.084ZM47.2461 16.3906C48.0664 16.3906 48.6855 16.5723 49.1035 16.9355C49.5254 17.2988 49.7363 17.8652 49.7363 18.6348V23H48.7578L48.4941 22.0801H48.4473C48.2637 22.3145 48.0742 22.5078 47.8789 22.6602C47.6836 22.8125 47.457 22.9258 47.1992 23C46.9453 23.0781 46.6348 23.1172 46.2676 23.1172C45.8809 23.1172 45.5352 23.0469 45.2305 22.9062C44.9258 22.7617 44.6855 22.543 44.5098 22.25C44.334 21.957 44.2461 21.5859 44.2461 21.1367C44.2461 20.4688 44.4941 19.9668 44.9902 19.6309C45.4902 19.2949 46.2441 19.1094 47.252 19.0742L48.377 19.0332V18.6934C48.377 18.2441 48.2715 17.9238 48.0605 17.7324C47.8535 17.541 47.5605 17.4453 47.1816 17.4453C46.8574 17.4453 46.543 17.4922 46.2383 17.5859C45.9336 17.6797 45.6367 17.7949 45.3477 17.9316L44.9023 16.959C45.2188 16.791 45.5781 16.6543 45.9805 16.5488C46.3867 16.4434 46.8086 16.3906 47.2461 16.3906ZM48.3711 19.9004L47.5332 19.9297C46.8457 19.9531 46.3633 20.0703 46.0859 20.2812C45.8086 20.4922 45.6699 20.7812 45.6699 21.1484C45.6699 21.4688 45.7656 21.7031 45.957 21.8516C46.1484 21.9961 46.4004 22.0684 46.7129 22.0684C47.1895 22.0684 47.584 21.9336 47.8965 21.6641C48.2129 21.3906 48.3711 20.9902 48.3711 20.4629V19.9004ZM54.2773 23.1172C53.6641 23.1172 53.1328 22.998 52.6836 22.7598C52.2344 22.5215 51.8887 22.1562 51.6465 21.6641C51.4043 21.1719 51.2832 20.5469 51.2832 19.7891C51.2832 19 51.416 18.3555 51.6816 17.8555C51.9473 17.3555 52.3145 16.9863 52.7832 16.748C53.2559 16.5098 53.7969 16.3906 54.4062 16.3906C54.793 16.3906 55.1426 16.4297 55.4551 16.5078C55.7715 16.582 56.0391 16.6738 56.2578 16.7832L55.8477 17.8848C55.6094 17.7871 55.3652 17.7051 55.1152 17.6387C54.8652 17.5723 54.625 17.5391 54.3945 17.5391C54.0156 17.5391 53.6992 17.623 53.4453 17.791C53.1953 17.959 53.0078 18.209 52.8828 18.541C52.7617 18.873 52.7012 19.2852 52.7012 19.7773C52.7012 20.2539 52.7637 20.6562 52.8887 20.9844C53.0137 21.3086 53.1992 21.5547 53.4453 21.7227C53.6914 21.8867 53.9941 21.9688 54.3535 21.9688C54.709 21.9688 55.0273 21.9258 55.3086 21.8398C55.5898 21.7539 55.8555 21.6426 56.1055 21.5059V22.7012C55.8594 22.8418 55.5957 22.9453 55.3145 23.0117C55.0332 23.082 54.6875 23.1172 54.2773 23.1172ZM60.2422 23.1172C59.6289 23.1172 59.0977 22.998 58.6484 22.7598C58.1992 22.5215 57.8535 22.1562 57.6113 21.6641C57.3691 21.1719 57.248 20.5469 57.248 19.7891C57.248 19 57.3809 18.3555 57.6465 17.8555C57.9121 17.3555 58.2793 16.9863 58.748 16.748C59.2207 16.5098 59.7617 16.3906 60.3711 16.3906C60.7578 16.3906 61.1074 16.4297 61.4199 16.5078C61.7363 16.582 62.0039 16.6738 62.2227 16.7832L61.8125 17.8848C61.5742 17.7871 61.3301 17.7051 61.0801 17.6387C60.8301 17.5723 60.5898 17.5391 60.3594 17.5391C59.9805 17.5391 59.6641 17.623 59.4102 17.791C59.1602 17.959 58.9727 18.209 58.8477 18.541C58.7266 18.873 58.666 19.2852 58.666 19.7773C58.666 20.2539 58.7285 20.6562 58.8535 20.9844C58.9785 21.3086 59.1641 21.5547 59.4102 21.7227C59.6562 21.8867 59.959 21.9688 60.3184 21.9688C60.6738 21.9688 60.9922 21.9258 61.2734 21.8398C61.5547 21.7539 61.8203 21.6426 62.0703 21.5059V22.7012C61.8242 22.8418 61.5605 22.9453 61.2793 23.0117C60.998 23.082 60.6523 23.1172 60.2422 23.1172ZM69.3359 19.7422C69.3359 20.2812 69.2656 20.7598 69.125 21.1777C68.9844 21.5957 68.7793 21.9492 68.5098 22.2383C68.2402 22.5234 67.916 22.7422 67.5371 22.8945C67.1582 23.043 66.7305 23.1172 66.2539 23.1172C65.8086 23.1172 65.4004 23.043 65.0293 22.8945C64.6582 22.7422 64.3359 22.5234 64.0625 22.2383C63.793 21.9492 63.584 21.5957 63.4355 21.1777C63.2871 20.7598 63.2129 20.2812 63.2129 19.7422C63.2129 19.0273 63.3359 18.4219 63.582 17.9258C63.832 17.4258 64.1875 17.0449 64.6484 16.7832C65.1094 16.5215 65.6582 16.3906 66.2949 16.3906C66.8926 16.3906 67.4199 16.5215 67.877 16.7832C68.334 17.0449 68.6914 17.4258 68.9492 17.9258C69.207 18.4258 69.3359 19.0312 69.3359 19.7422ZM64.6309 19.7422C64.6309 20.2148 64.6875 20.6191 64.8008 20.9551C64.918 21.291 65.0977 21.5488 65.3398 21.7285C65.582 21.9043 65.8945 21.9922 66.2773 21.9922C66.6602 21.9922 66.9727 21.9043 67.2148 21.7285C67.457 21.5488 67.6348 21.291 67.748 20.9551C67.8613 20.6191 67.918 20.2148 67.918 19.7422C67.918 19.2695 67.8613 18.8691 67.748 18.541C67.6348 18.209 67.457 17.957 67.2148 17.7852C66.9727 17.6094 66.6582 17.5215 66.2715 17.5215C65.7012 17.5215 65.2852 17.7129 65.0234 18.0957C64.7617 18.4785 64.6309 19.0273 64.6309 19.7422ZM76.5723 16.5137V23H75.4883L75.3008 22.127H75.2246C75.0879 22.3496 74.9141 22.5352 74.7031 22.6836C74.4922 22.8281 74.2578 22.9355 74 23.0059C73.7422 23.0801 73.4707 23.1172 73.1855 23.1172C72.6973 23.1172 72.2793 23.0352 71.9316 22.8711C71.5879 22.7031 71.3242 22.4453 71.1406 22.0977C70.957 21.75 70.8652 21.3008 70.8652 20.75V16.5137H72.248V20.4922C72.248 20.9961 72.3496 21.373 72.5527 21.623C72.7598 21.873 73.0801 21.998 73.5137 21.998C73.9316 21.998 74.2637 21.9121 74.5098 21.7402C74.7559 21.5684 74.9297 21.3145 75.0312 20.9785C75.1367 20.6426 75.1895 20.2305 75.1895 19.7422V16.5137H76.5723ZM81.9277 16.3906C82.6582 16.3906 83.2266 16.5801 83.6328 16.959C84.043 17.334 84.248 17.9375 84.248 18.7695V23H82.8711V19.0273C82.8711 18.5234 82.7676 18.1465 82.5605 17.8965C82.3535 17.6426 82.0332 17.5156 81.5996 17.5156C80.9707 17.5156 80.5332 17.709 80.2871 18.0957C80.0449 18.4824 79.9238 19.043 79.9238 19.7773V23H78.5469V16.5137H79.6191L79.8125 17.3926H79.8887C80.0293 17.166 80.2031 16.9805 80.4102 16.8359C80.6211 16.6875 80.8555 16.5762 81.1133 16.502C81.375 16.4277 81.6465 16.3906 81.9277 16.3906ZM88.5898 22.0039C88.7695 22.0039 88.9473 21.9883 89.123 21.957C89.2988 21.9219 89.459 21.8809 89.6035 21.834V22.877C89.4512 22.9434 89.2539 23 89.0117 23.0469C88.7695 23.0938 88.5176 23.1172 88.2559 23.1172C87.8887 23.1172 87.5586 23.0566 87.2656 22.9355C86.9727 22.8105 86.7402 22.5977 86.5684 22.2969C86.3965 21.9961 86.3105 21.5801 86.3105 21.0488V17.5625H85.4258V16.9473L86.375 16.4609L86.8262 15.0723H87.6934V16.5137H89.5508V17.5625H87.6934V21.0312C87.6934 21.3594 87.7754 21.6035 87.9395 21.7637C88.1035 21.9238 88.3203 22.0039 88.5898 22.0039ZM95.2812 21.1484C95.2812 21.5742 95.1777 21.9336 94.9707 22.2266C94.7637 22.5195 94.4609 22.7422 94.0625 22.8945C93.668 23.043 93.1836 23.1172 92.6094 23.1172C92.1562 23.1172 91.7656 23.084 91.4375 23.0176C91.1133 22.9551 90.8066 22.8574 90.5176 22.7246V21.5352C90.8262 21.6797 91.1719 21.8047 91.5547 21.9102C91.9414 22.0156 92.3066 22.0684 92.6504 22.0684C93.1035 22.0684 93.4297 21.998 93.6289 21.8574C93.8281 21.7129 93.9277 21.5215 93.9277 21.2832C93.9277 21.1426 93.8867 21.0176 93.8047 20.9082C93.7266 20.7949 93.5781 20.6797 93.3594 20.5625C93.1445 20.4414 92.8281 20.2969 92.4102 20.1289C92 19.9648 91.6543 19.8008 91.373 19.6367C91.0918 19.4727 90.8789 19.2754 90.7344 19.0449C90.5898 18.8105 90.5176 18.5117 90.5176 18.1484C90.5176 17.5742 90.7441 17.1387 91.1973 16.8418C91.6543 16.541 92.2578 16.3906 93.0078 16.3906C93.4062 16.3906 93.7812 16.4316 94.1328 16.5137C94.4883 16.5918 94.8359 16.707 95.1758 16.8594L94.7422 17.8965C94.4492 17.7676 94.1543 17.6621 93.8574 17.5801C93.5645 17.4941 93.2656 17.4512 92.9609 17.4512C92.6055 17.4512 92.334 17.5059 92.1465 17.6152C91.9629 17.7246 91.8711 17.8809 91.8711 18.084C91.8711 18.2363 91.916 18.3652 92.0059 18.4707C92.0957 18.5762 92.25 18.6816 92.4688 18.7871C92.6914 18.8926 93 19.0234 93.3945 19.1797C93.7812 19.3281 94.1152 19.4844 94.3965 19.6484C94.6816 19.8086 94.9004 20.0059 95.0527 20.2402C95.2051 20.4746 95.2812 20.7773 95.2812 21.1484Z"
          fill="white"
          className="cursor-pointer"
          onClick={() => {
            history.push(`${path}/accounts`);
          }}
        />
      </g>

      <g>
        <path
          d="M322.22 26.4666C322.601 20.8425 327.131 16.4493 332.761 16.1616C334.629 16.0661 336.511 16 338.142 16C339.683 16 341.45 16.0591 343.218 16.1463C348.985 16.4307 353.568 21.0229 353.851 26.7903C353.939 28.6031 354 30.419 354 32C354 33.581 353.939 35.3969 353.851 37.2097C353.568 42.9771 348.985 47.5693 343.218 47.8537C341.45 47.9409 339.683 48 338.142 48C336.511 48 334.629 47.9339 332.761 47.8384C327.131 47.5507 322.601 43.1575 322.22 37.5334C322.091 35.6148 322 33.6763 322 32C322 30.3237 322.091 28.3852 322.22 26.4666Z"
          fill="white"
          fillOpacity="0.1"
          onClick={handleFlip}
          className="cursor-pointer"
        />
        <rect
          x="330.5"
          y="27"
          width="15"
          height="10.8333"
          rx="2"
          stroke="white"
          strokeWidth="1.5"
          onClick={handleFlip}
          className="cursor-pointer"
        />
        <path
          d="M333.834 34.5H333.842"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          onClick={handleFlip}
          className="cursor-pointer"
        />
        <path
          d="M331.334 31.166H345.501"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          onClick={handleFlip}
          className="cursor-pointer"
        />
      </g>

      <text fill="white" fontWeight="600" fontSize={12} x={20} y={40}>
        {label}
      </text>

      <defs>
        <linearGradient
          id="paint0_linear_19084_153888"
          x1="370"
          y1="0.24809"
          x2="292.961"
          y2="280.088"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.390033" stopColor="white" stopOpacity="0.33" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19084_153888"
          x1="-7.18182e-07"
          y1="100"
          x2="370"
          y2="102.5"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0.6" />
        </linearGradient>
        <clipPath id="clip0_19084_153888">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
        <clipPath id="clip1_19084_153888">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
      </defs>
    </svg>
  );
};

ActiveCard.propTypes = {
  openCardCurrencyNote: PropTypes.func.isRequired,
  openCardSettingModal: PropTypes.func.isRequired,
  cardStatus: PropTypes.object.isRequired,
  cardProvider: PropTypes.string.isRequired,
  handleFlip: PropTypes.func.isRequired,
  amount: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
